// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dc19d041","239":"5496e1ac","453":"7775b772","455":"968c1541"}[chunkId] + ".chunk.js";
};